import { DPP_USER_DATA_KEY } from '@/data/dpp/constants';
import { fetchDppMemberPromotion } from '@/data/dpp/promotionClient';
import { useSettings, useSingleSettings } from '@/data/Settings';
import { useUser } from '@/data/User';
import useSWR from 'swr';

const DATA_KEY_DPP_MEMBER_PROMOTION = 'DppMemberPromotion';

/** Promoción DPP vigente del cliente con sesión. Para invitados no se consulta el servicio. */
export const useDppMemberPromotion = () => {
	const { settings } = useSettings();
	const { user, loading: loadingUser } = useUser();
	const storeId = settings?.storeId;
	const memberId = user?.isLoggedIn ? user.userId : undefined;

	const { data, error, isLoading } = useSWR(
		storeId && memberId ? [storeId, memberId, DATA_KEY_DPP_MEMBER_PROMOTION] : null,
		([storeId, memberId]) => fetchDppMemberPromotion(storeId, memberId),
		{ revalidateOnFocus: false, shouldRetryOnError: false }
	);

	return {
		promotion: data ?? undefined,
		loading: loadingUser || isLoading,
		error,
	};
};

/** Landing personal configurada en el storeconf, para elementos que no vienen del CMS. */
export const useDppLandingHref = () => {
	const { settings } = useSingleSettings();
	return settings?.userData?.[DPP_USER_DATA_KEY.landingHref]?.trim() || undefined;
};
